<script setup lang="ts">
import Spinner from "@/components/icons/Spinner.vue";

type IProps = {
  show: boolean;
}
const props = defineProps<IProps>();
</script>

<template>
  <div v-if="props.show"
       class="absolute top-0 left-0 w-full h-full backdrop-blur-sm bg-white/30 rounded-[20px] text-center">
    <div class="flex justify-center items-center w-full h-full">
      <slot name="loader">
        <Spinner />
      </slot>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
